import { VisitSettlement } from '@dreryk/egabinet-financial-settlement-frontend-api';

export const isInvoiceCreateButtonAvailable = (
   invoiceCreateAvailable: boolean,
   invoiceProviderIntegrationEnabled: boolean,
   visitSettlement: VisitSettlement | null
): boolean => {
   if (invoiceProviderIntegrationEnabled === false) {
      return false;
   }

   return Boolean(invoiceCreateAvailable && visitSettlement && visitSettlement.settlementStatus !== 'UNSETTLED');
};
